// NFT DAO Utils Contract ABI
export const NFT_DAO_UTILS_ABI = [
	{
		"inputs": [],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"inputs": [
			{
				"internalType": "uint256[]",
				"name": "tokenIds",
				"type": "uint256[]"
			},
			{
				"internalType": "string",
				"name": "key",
				"type": "string"
			}
		],
		"name": "getNftClaimStatus",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "tokenId",
						"type": "uint256"
					},
					{
						"internalType": "bool",
						"name": "isClaimed",
						"type": "bool"
					},
					{
						"internalType": "bool",
						"name": "isEligible",
						"type": "bool"
					}
				],
				"internalType": "struct NftDaoUtils.NftClaimData[]",
				"name": "claimDataArray",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
		],
		"name": "getNftData",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "tokenId",
						"type": "uint256"
					},
					{
						"internalType": "string",
						"name": "tokenURI",
						"type": "string"
					},
					{
						"internalType": "uint256",
						"name": "level",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "mintTime",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "owner",
						"type": "address"
					}
				],
				"internalType": "struct NftDaoUtils.NftData",
				"name": "nftData",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			},
			{
				"internalType": "string",
				"name": "key",
				"type": "string"
			}
		],
		"name": "getNftRewardData",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "tokenId",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "level",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "rewardAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "rewardAmountLRSN",
						"type": "uint256"
					},
					{
						"internalType": "bool",
						"name": "isEligible",
						"type": "bool"
					},
					{
						"internalType": "bool",
						"name": "isFinalized",
						"type": "bool"
					}
				],
				"internalType": "struct NftDaoUtils.NftRewardData",
				"name": "rewardData",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "string",
				"name": "key",
				"type": "string"
			}
		],
		"name": "getRewardPeriodInfo",
		"outputs": [
			{
				"internalType": "bool",
				"name": "isFinalized",
				"type": "bool"
			},
			{
				"internalType": "uint256",
				"name": "lastId",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "totalReward",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "totalRewardLRSN",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "l1Reward",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "l2Reward",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "l3Reward",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "l1RewardLRSN",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "l2RewardLRSN",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "l3RewardLRSN",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			},
			{
				"internalType": "string",
				"name": "key",
				"type": "string"
			}
		],
		"name": "getSingleNftClaimStatus",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "tokenId",
						"type": "uint256"
					},
					{
						"internalType": "bool",
						"name": "isClaimed",
						"type": "bool"
					},
					{
						"internalType": "bool",
						"name": "isEligible",
						"type": "bool"
					}
				],
				"internalType": "struct NftDaoUtils.NftClaimData",
				"name": "claimData",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "userAddress",
				"type": "address"
			}
		],
		"name": "getUserNftCount",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "count",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "userAddress",
				"type": "address"
			},
			{
				"internalType": "string",
				"name": "key",
				"type": "string"
			}
		],
		"name": "getUserNftRewards",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "tokenId",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "level",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "rewardAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "rewardAmountLRSN",
						"type": "uint256"
					},
					{
						"internalType": "bool",
						"name": "isEligible",
						"type": "bool"
					},
					{
						"internalType": "bool",
						"name": "isFinalized",
						"type": "bool"
					}
				],
				"internalType": "struct NftDaoUtils.NftRewardData[]",
				"name": "rewardDataArray",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "userAddress",
				"type": "address"
			}
		],
		"name": "getUserNfts",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "tokenId",
						"type": "uint256"
					},
					{
						"internalType": "string",
						"name": "tokenURI",
						"type": "string"
					},
					{
						"internalType": "uint256",
						"name": "level",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "mintTime",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "owner",
						"type": "address"
					}
				],
				"internalType": "struct NftDaoUtils.NftData[]",
				"name": "nftDataArray",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "userAddress",
				"type": "address"
			},
			{
				"internalType": "string",
				"name": "key",
				"type": "string"
			}
		],
		"name": "getUserNftsWithRewards",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "tokenId",
						"type": "uint256"
					},
					{
						"internalType": "string",
						"name": "tokenURI",
						"type": "string"
					},
					{
						"internalType": "uint256",
						"name": "level",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "mintTime",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "owner",
						"type": "address"
					},
					{
						"internalType": "uint256",
						"name": "rewardAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "rewardAmountLRSN",
						"type": "uint256"
					},
					{
						"internalType": "bool",
						"name": "isEligible",
						"type": "bool"
					},
					{
						"internalType": "bool",
						"name": "isFinalized",
						"type": "bool"
					}
				],
				"internalType": "struct NftDaoUtils.NftDataWithReward[]",
				"name": "nftDataWithRewardArray",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "userAddress",
				"type": "address"
			},
			{
				"internalType": "string",
				"name": "key",
				"type": "string"
			}
		],
		"name": "getUserRewardSummary",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "totalReward",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "totalRewardLRSN",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "claimableReward",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "claimableRewardLRSN",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "eligibleCount",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "claimedCount",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "userAddress",
				"type": "address"
			}
		],
		"name": "getUserTokenIds",
		"outputs": [
			{
				"internalType": "uint256[]",
				"name": "tokenIds",
				"type": "uint256[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "larissaDaoContract",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "nftContract",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
] as const;

// Types for NFT data
export interface NftData {
	tokenId: bigint;
	tokenURI: string;
	level: bigint;
	mintTime: bigint;
	owner: `0x${string}`;
}

export interface NftRewardData {
	tokenId: bigint;
	level: bigint;
	rewardAmount: bigint;
	rewardAmountLRSN: bigint;
	isEligible: boolean;
	isFinalized: boolean;
}

export interface NftDataWithReward extends NftData {
	rewardAmount: bigint;
	rewardAmountLRSN: bigint;
	isEligible: boolean;
	isFinalized: boolean;
}

export interface NftClaimData {
	tokenId: bigint;
	isClaimed: boolean;
	isEligible: boolean;
}

export interface RewardPeriodInfo {
	isFinalized: boolean;
	lastId: bigint;
	totalReward: bigint;
	totalRewardLRSN: bigint;
	l1Reward: bigint;
	l2Reward: bigint;
	l3Reward: bigint;
	l1RewardLRSN: bigint;
	l2RewardLRSN: bigint;
	l3RewardLRSN: bigint;
}

export interface RewardSummary {
	totalReward: bigint;
	totalRewardLRSN: bigint;
	claimableReward: bigint;
	claimableRewardLRSN: bigint;
	eligibleCount: bigint;
	claimedCount: bigint;
}
